import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import iceRiverSvg from "../../../assets/images/svg/iceRiver.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useGlacierCreateMutation, useGlacierDeleteMutation, useGlacierFindAllQuery, useGlacierUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";


const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [glacierOne, setGlacierOne] = useState<any>();
  const [glacierList, setGlacierList] = useState<any>();
  const [glacierCount, setGlacierCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useGlacierFindAllQuery(customQuery);
  const [saveBorder, setSaveBorder] = useState<boolean>(false);

  const [glacierUpdate, glacierUpdateResult] = useGlacierUpdateMutation();
  const [glacierCreate, glacierCreateResult] = useGlacierCreateMutation();
  const [glacierDelete, glacierDeleteResult] = useGlacierDeleteMutation();

  const {
    data: commonGlacier,
    error: commonGlacierError,
    isFetching: isCommonGlacierFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_glacier_type`);

  useEffect(() => {
    setGlacierList(data?.data);
    setLoading(false);
    setGlacierCount(glacierList?.length);

    const tempSaveBorder = glacierOne !== null ? glacierOne?.save_border : false;
    setSaveBorder(tempSaveBorder)

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, glacierList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setGlacierOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const glacierData = arg;
    setGlacierOne({
      id: glacierData.id,
      code: glacierData.code,
      name: glacierData.name,
      child_info: glacierData.child_info,
      cmd_glacier_type: glacierData.cmd_glacier_type,
      location: glacierData?.location,
      save_border_desicion: glacierData.save_border_desicion,
    });

    setSaveBorder(glacierData?.save_border)

    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (glacierData) => {
    setGlacierOne(glacierData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (glacierOne) {
      glacierDelete(glacierOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setGlacierOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Мөсөн голын төрөл",
        accessorKey: "glacier_type_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Хамгаалалтын бүстэй эсэх",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border",
        cell: (cellProps: any) => {
          switch (cellProps.row.original.save_border) {
            case true:
              return (
                <span className="badge badge-soft-success fw-semibold fs-6 text">
                  Тийм
                </span>
              );
            default:
              return (
                <span className="badge badge-soft-warning fw-semibold fs-6 text">
                  Үгүй
                </span>
              );
          }
        },
      },
      {
        header: "Хамгаалалтын бүсийн шийдвэр",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "save_border_desicion",
      },

      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/surface/water/ice-river/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const glacierData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(glacierData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const glacierData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(glacierData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code: glacierOne?.code,
      name: glacierOne?.name,
      cmd_glacier_type: glacierOne?.cmd_glacier_type,
      location: glacierOne?.location,
      save_border_desicion: glacierOne?.save_border_desicion,
      child_info: glacierOne?.child_info,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmd_glacier_type: Yup.string().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      child_info: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      if (isEdit) {
        formData.append('id', glacierOne ? glacierOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_glacier_type', values?.cmd_glacier_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('child_info', values?.child_info);
        glacierUpdate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
      } else {
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('cmd_glacier_type', values?.cmd_glacier_type);
        formData.append('location', values?.location);
        formData.append('save_border', String(saveBorder ?? false));
        formData.append('save_border_desicion', values?.save_border_desicion);
        formData.append('child_info', values?.child_info);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
        glacierCreate(formData)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай орлоо!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
        setResetFiles(true);
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };


  return (
    <React.Fragment>
      <DeleteModal
        deleteName={glacierOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={iceRiverSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(glacierCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={glacierList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Мөсөн гол мэдээлэл засах" : "Мөсөн гол мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Голын бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Голын нэр  *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Мөстөл, мөсөн голоос эх авсан гол, горхи *</Label>
                  <Input
                    name="child_info"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.child_info || ""}
                    invalid={
                      validation.touched.child_info && validation.errors.child_info
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.child_info && validation.errors.child_info ? (
                    <FormFeedback status="invalid">
                      {validation.errors.child_info}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="text-danger">Байршил *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">	Голын төрөл *</Label>
                  <Input
                    name="cmd_glacier_type"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmd_glacier_type || ""}
                    invalid={
                      validation.touched.cmd_glacier_type &&
                        validation.errors.cmd_glacier_type
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonGlacier?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmd_glacier_type &&
                    validation.errors.cmd_glacier_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmd_glacier_type}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Хамгаалалтын бүстэй эсэх*</Label> <br />
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    className="me-1 mb-sm-8 mb-2 ms-3"
                    onColor="#626ed4"
                    onChange={() => {
                      setSaveBorder(!saveBorder);
                    }}
                    checked={saveBorder}
                  />
                </div>
                <div>
                  <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>
                  <Input
                    name="save_border_desicion"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.save_border_desicion || ""}
                    invalid={
                      validation.touched.save_border_desicion && validation.errors.save_border_desicion
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                    <FormFeedback status="invalid">
                      {validation.errors.save_border_desicion}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'multipolygon'} />
              </Row>
            }

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
